import { Colors } from 'shared/theme/colors'
import { STANDARD_WRAPPER_WIDTH } from 'shared/theme/constants'
import { inputActiveLabel } from 'shared/theme/mixins'
import { header3, paragraph3 } from 'shared/theme/typography'
import styled, { css } from 'styled-components'

import InputMask from '../../vendor/react-input-mask/src/index.jsx'

export const Label = styled.label<{ $active: boolean }>`
  position: absolute;
  top: 17px;
  left: 16px;
  transition: all 0.2s;
  touch-action: manipulation;
  ${header3};
  font-size: 16px !important;
  color: ${Colors.lightGray2};

  ${({ $active }) => $active && inputActiveLabel}
`

export const Field = styled.div<{
  $hasError: boolean
  $backgroundColor?: string
  $noMargin?: boolean
  $maxWidth?: string
}>`
  position: relative;
  display: flex;
  flex-flow: column-reverse;
  margin-bottom: 24px;
  padding: 16px 1px 0 1px;
  background-color: ${Colors.white};
  border-radius: 3px;
  height: 56px;
  width: 100%;
  max-width: ${STANDARD_WRAPPER_WIDTH};
  min-width: 120px;
  ${({ $backgroundColor }) => $backgroundColor && `background-color: ${$backgroundColor};`}
  ${({ $hasError }) =>
    $hasError && `border: 1px solid ${Colors.errorD1}; background-color: ${Colors.errorL1};`}
  ${({ $noMargin }) => $noMargin && `margin-bottom: 0;`}
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth};`}

  &:hover {
    cursor: pointer;
  }

  &:focus-within > ${Label} {
    transform: scale(0.8);
    transform-origin: top left;
    cursor: pointer;
    color: ${Colors.cyanD1};
    top: 2px;
    left: 14px;
    font-weight: 500;
    ${({ $hasError }) => $hasError && `color: ${Colors.lightGray2};`};
  }
`

export const MaskedInput = styled(InputMask).attrs<{ $error?: boolean; $backgroundColor?: string }>(
  (props) => ({
    'aria-invalid': props.$error,
  })
)`
  ${header3};
  font-size: 16px !important;
  transition: all 0.2s;
  touch-action: manipulation;
  border: 0;
  border-bottom: 1px solid transparent;
  background: transparent;
  padding: 4px 15px;
  caret-color: ${Colors.cyan};

  &:focus {
    outline: 0;
    border-bottom: 1px solid ${Colors.cyanD1};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    /* stylelint-disable */
    ${({ $backgroundColor }) =>
      `-webkit-box-shadow: 0 0 0 9999px ${$backgroundColor || Colors.white} inset !important;`}
    ${({ $backgroundColor }) =>
      `box-shadow: 0 0 0 9999px  ${$backgroundColor || Colors.white} inset !important;`}
    /* stylelint-enable */
    background-color: transparent !important;
    background-clip: content-box !important;
  }

  ${({ $error }) => $error && `background-color: ${Colors.errorL1} !important;`}
`

export const DateInputStyled = styled(MaskedInput)`
  padding-left: 50px;
`

const helperText = css`
  ${paragraph3};
  position: absolute;
  top: 60px;
  left: 0;
`

export const ErrorMessage = styled.div`
  ${helperText};
  color: ${Colors.errorD1};

  &::first-letter {
    text-transform: capitalize;
  }
`

export const HelperMessage = styled.div`
  ${helperText};
  color: ${Colors.midGray};
`
